export default __webpack_public_path__ + "static/media/Map_Mast.f5d3aedb.svg";